export default __webpack_public_path__ + "images/kn_21e17c.svg";